import { deleteArtPresentacion, getArtPresentacionesPanel,postArtPresentacion } from "../../services/ArticulosPresentacionesServices";
import { ArticulosPresentacionesContext } from "./ArticulosPresentacionesContext"

export const ArticulosPresentacionesState = ({ children }) => {
    const getArtPresentacionesPanelData = async (searchRam,searchTerm, page, perPage) => {
        let res = await getArtPresentacionesPanel(searchRam,searchTerm, page, perPage)
        return res;
    }

    const deleteArticuloPresentacionData = async (body) => {
        const res = await deleteArtPresentacion(body)
        return res
    }

    const postArticuloPresentacionData = async (body) => {
        const res = await postArtPresentacion(body)
        return res
    }
    return <ArticulosPresentacionesContext.Provider value={{
        deleteArticuloPresentacionData,
        getArtPresentacionesPanelData,
        postArticuloPresentacionData
    }} >
        {children}
    </ArticulosPresentacionesContext.Provider>
}